/**
    При скролле вниз прячем хедер,
    при скроле вверх — показываем
*/

import { throttle } from './ThrottleDebounce.js';


const $header = $('.js-header');
let prevScroll = 0;


function detectHeader() {
    const scrollTop = App.W.scrollTop();

    if (prevScroll > scrollTop || scrollTop < 100) {
        $header.removeClass('_hidden');
    } else {
        $header.addClass('_hidden');
    }

    prevScroll = scrollTop;

    detectCompact(scrollTop);
}



/**
    Если это не самый верх страницы, хедер делаем
    компактным
*/
function detectCompact(scrollTop) {
    if (scrollTop > 30) {
        $header.addClass('_compact');
    } else {
        $header.removeClass('_compact');
    }
}

detectCompact(App.W.scrollTop());



/** Биндим после первого скролла, чтобы
    не было лишнего срабатывания сразу при
    загрузке страницы
*/
App.W.one('scroll', () => {
    prevScroll = 9999;
    App.W.on('scroll.header', throttle(detectHeader, 50));
});



// WEBPACK FOOTER //
// ./_src/js/modules/FixedHeader.js